import { useTranslation } from 'react-i18next'

import { clsx } from 'clsx'

import s from './styles.module.scss'

export const SchemeInfo = () => {
  const { t } = useTranslation()

  return (
    <div className={s.container}>
      <div className={clsx('regular-14', s.info)}>
        <span className={clsx(s.box, s.occupied)} />

        {t('beket.info.occupied')}
      </div>

      <div className={clsx('regular-14', s.info)}>
        <span className={clsx(s.box, s.free)} />

        {t('beket.info.free')}
      </div>

      <div className={clsx('regular-14', s.info)}>
        <span className={clsx(s.box, s.selected)} />

        {t('beket.info.selected')}
      </div>
    </div>
  )
}
